import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MfaLoginDataWithToken } from '../../../models/User/mfa/mfa-tokens/mfa-login-data';
import { ActivatedRoute } from '@angular/router';
import { MfaLoginService } from '../../../services/authentication/mfa-login.service';
import { MfaType } from '../../../models/enums/mfa-type';
import { MfaSetUpOtpComponent } from '../../../shared-components/mfa-setup/mfa-setup-otp/mfa-setup-otp.component';
import { ScreenWidthListenerService } from '../../../services/screen-width-detector/screen-width-listener.service';
import { Subscription } from 'rxjs';
import { SessionStatusBroadcastService } from '../../../services/authorization/session-status-broadcast.service';
import { BroadcastMessage } from '../../../models/broadcast/broadcast-message';
import { BroadcastMessageType } from '../../../models/broadcast/broadcast-message-type';

@Component({
	selector: 'eif-mfa-setup-otp-page',
	templateUrl: './mfa-setup-otp-page.component.html',
	styleUrls: ['./mfa-setup-otp-page.component.scss'],
	standalone: false,
})
export class MfaSetUpOtpPageComponent implements OnInit, OnDestroy {
	@ViewChild('mfaSetUpOtp') mfaSetUpOtp: MfaSetUpOtpComponent;

	protected mfaData: MfaLoginDataWithToken;
	protected componentLoaded: Promise<boolean>;
	private sessionKilledSubscription: Subscription;

	constructor(
		protected screenWidthListener: ScreenWidthListenerService,
		private route: ActivatedRoute,
		private mfaLoginService: MfaLoginService,
		private sessionStatusBroadcastService: SessionStatusBroadcastService
	) {}

	ngOnInit(): void {
		this.mfaLoginService.getMfaLoginDataFromRoute(this.route).then((mfaData: MfaLoginDataWithToken) => {
			this.mfaData = mfaData;
			if (!!this.mfaData?.MfaToken) {
				this.subscribeSessionKill();
				this.componentLoaded = Promise.resolve(true);
			} else {
				this.goBack();
			}
		});
	}

	ngOnDestroy(): void {
		this.unsubscribeSessionKill();
	}

	private subscribeSessionKill(): void {
		this.sessionKilledSubscription = this.sessionStatusBroadcastService
			.messagesOfType(BroadcastMessageType.SessionKilled)
			.subscribe((msg: BroadcastMessage) => {
				if (msg.type == BroadcastMessageType.SessionKilled) {
					this.unsubscribeSessionKill();
					this.mfaLoginService.cancelMfaLogin();
				}
			});
	}

	private unsubscribeSessionKill(): void {
		if (!!this.sessionKilledSubscription) {
			this.sessionKilledSubscription.unsubscribe();
		}
	}

	protected confirmSetUpSuccess(): void {
		const index = this.mfaData.MfaLoginData.UserMfaAuthenticators?.findIndex((userMfa) => userMfa.MfaTypeName === MfaType.OTP) ?? -1;
		if (index === -1) {
			// PR: The user cannot confirm OTP set up without the authenticator being registered somehow (Active or otherwise).
			this.goBack();
			return;
		}

		// PR: For security purposes the current MFA login process is cancelled.
		// The user then logs in again, this time having the OTP authenticator active and available.
		this.mfaLoginService.cancelMfaLogin();
	}

	protected goBack(): void {
		this.mfaLoginService.cancelMfaLogin();
	}
}
